import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=684c5080&scoped=true&"
import script from "./Employee.vue?vue&type=script&lang=js&"
export * from "./Employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c5080",
  null
  
)

export default component.exports